import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "./TitolHeader.module.css";
import { getTitolApartat } from "../reducers";

class TitolHeader extends Component {
  render() {
    const { titolApartat } = this.props;
    return <h1 className={styles.titol}>{titolApartat}</h1>;
  }
}

TitolHeader.propTypes = {
  titolApartat: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  titolApartat: getTitolApartat(state)
});

export default connect(mapStateToProps)(TitolHeader);
